import React, { useState } from 'react';
// import FontContent from './custom/fontContent';
// import AddTheme from './AddTheme';
// import ExampleColorPicker from './exampleColorPicker';
import { SketchPicker } from 'react-color';
import reactCSS from 'reactcss';
import ExampleColorPickerView from './exampleColorPickerView';
import ListFont from './custom/ListFont';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { withStyles } from '@material-ui/core/styles';
import { InputBase } from '@material-ui/core';
import { useMediaQuery } from 'react-responsive';

const BootstrapInput = withStyles((theme) => ({
  root: {
    'label + &': {
      marginTop: theme.spacing(3),
    },
  },
  input: {
    borderRadius: 4,
    position: 'relative',
    backgroundColor: theme.palette.background.paper,
    border: '1px solid #ced4da',
    fontSize: 16,
    padding: '10px 26px 10px 12px',
    transition: theme.transitions.create(['border-color', 'box-shadow']),
    // Use the system font instead of the default Roboto font.
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      '"Segoe UI"',
      'Roboto',
      '"Helvetica Neue"',
      'Arial',
      'sans-serif',
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(','),
    '&:focus': {
      borderRadius: 4,
      borderColor: '#80bdff',
      boxShadow: '0 0 0 0.2rem rgba(0,123,255,.25)',
    },
  },
}))(InputBase);

// const initialState = {
//   style: {
//     fontType: '',
//     paperColor: '',
//     backgroundPaperColor: '',
//     backgroundImagePaperColor: '',
//     questionColor: '',
//     answerColor: '',
//     stripColor: '',
//     backgroundButtonColor: '',
//   },
//   name: '',
//   description: '',
//   pictureURL: '',
//   type: '',
// };

export function AddThemeContent({ func }) {
  const [defaultFont, setDefaultFont] = useState('Poppins');
  const [colorHexPaperCode, setColorHexPaperCode] = useState('#FFF8DC');
  const [colorHexPaperBgCode, setColorHexPaperBgCode] = useState('#F7E59D');
  const [colorHexQuestionCode, setColorHexQuestionCode] = useState('#9013FE');
  const [colorHexAnswerCode, setColorHexAnswerCode] = useState('#F97D4E');
  const [colorHexStripCode, setColorHexStripCode] = useState('#4A90E2');
  const [colorHexButtonCode, setColorHexButtonCode] = useState('#B83400');

  const [newTheme, setNewTheme] = useState({
    fontType: `${defaultFont}`,
    paperColor: `${colorHexPaperCode}`,
    backgroundPaperColor: `${colorHexPaperBgCode}`,
    backgroundImagePaperColor: ``,
    questionColor: `${colorHexQuestionCode}`,
    answerColor: `${colorHexAnswerCode}`,
    stripColor: `${colorHexStripCode}`,
    backgroundButtonColor: `${colorHexButtonCode}`,
  });

  const [displayCPPaper, setDisplayCPPaper] = useState(false);
  const [displayCPBgPaper, setDisplayCPBgPaper] = useState(false);
  const [displayCPQuestion, setDisplayCPQuestion] = useState(false);
  const [displayCPAnswer, setDisplayCPAnswer] = useState(false);
  const [displayCPStrip, setDisplayCPStrip] = useState(false);
  const [displayCPButton, setDisplayCPButton] = useState(false);

  // console.log('INI THEME STATE', newTheme);

  func(newTheme); //oper state to parent Add

  const handleDisplayCPPaper = () => {
    setDisplayCPPaper(!displayCPPaper);
  };
  const handleDisplayCPBgPaper = () => {
    setDisplayCPBgPaper(!displayCPBgPaper);
  };
  const handleDisplayCPQuestion = () => {
    setDisplayCPQuestion(!displayCPQuestion);
  };
  const handleDisplayCPAnswer = () => {
    setDisplayCPAnswer(!displayCPAnswer);
  };
  const handleDisplayCPStrip = () => {
    setDisplayCPStrip(!displayCPStrip);
  };
  const handleDisplayCPButton = () => {
    setDisplayCPButton(!displayCPButton);
  };

  const handleChangeColor = (color) => {
    setColorHexPaperCode(color);
  };

  const handleChangeFont = (event) => {
    setDefaultFont({ defaultFont: event.target.value });
  };

  const handleClose = () => {
    setDisplayCPPaper(false);
  };

  const changeQuestion = (e, text, i) => {
    // var newQuestion = [...questions];
    // newQuestion[i].questionText = text;
    // setQuestions(newQuestion);
    // console.log(newQuestion);
    setColorHexQuestionCode(e.hex);
    // setNewTheme({ questionColor: colorHexQuestionCode });
    setNewTheme({
      fontType: defaultFont,
      paperColor: colorHexPaperCode,
      backgroundPaperColor: colorHexPaperBgCode,
      backgroundImagePaperColor: ``,
      questionColor: colorHexQuestionCode,
      answerColor: colorHexAnswerCode,
      stripColor: colorHexStripCode,
      backgroundButtonColor: colorHexButtonCode,
    });
  };

  const styles = reactCSS({
    default: {
      paperColor: {
        background: `${colorHexPaperCode}`,
      },
      paperColorTrigger: {
        border: '2px solid #808080',
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: '#505050',
        background: `${colorHexPaperCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      bgPaperColor: {
        background: `${colorHexPaperBgCode}`,
      },
      bgPaperColorTrigger: {
        border: '2px solid #808080',
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: `white`,
        background: `${colorHexPaperBgCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      questionColor: {
        color: `${colorHexQuestionCode}`,
      },
      questionColorTrigger: {
        border: '2px solid #808080',
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: `white`,
        background: `${colorHexQuestionCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      answerColor: {
        color: `${colorHexAnswerCode}`,
      },
      answerColorTrigger: {
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: `white`,
        background: `${colorHexAnswerCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      stripColor: {
        background: `${colorHexStripCode}`,
      },
      stripColorTrigger: {
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: `white`,
        background: `${colorHexStripCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      buttonBgColor: {
        color: `${colorHexButtonCode}`,
      },
      buttonBgColorTrigger: {
        width: '100px',
        padding: '2px 10px',
        borderRadius: '2px',
        color: `white`,
        background: `${colorHexButtonCode}`,
        display: 'flex',
        justifyContent: 'center',
      },
      fontStylee: {
        fontFamily: 'Roboto',
      },
      popover: {
        position: 'absolute',
        zIndex: '2',
      },
      cover: {
        position: 'fixed',
        top: '0px',
        right: '0px',
        bottom: '0px',
        left: '0px',
      },
      swatch: {
        padding: '5px',
        background: '#fff',
        borderRadius: '1px',
        // boxShadow: "0 1px 0 0 rgba(0,0.1,0,0)",
        // border: "1px solid #DCDCDC",
        display: 'inline-block',
        cursor: 'pointer',
      },
    },
  });

  const Desktop = ({ children }) => {
    const isDesktop = useMediaQuery({ minWidth: 1024 });
    return isDesktop ? children : Default;
  };
  const Tablet = ({ children }) => {
    const isTablet = useMediaQuery({ minWidth: 768, maxWidth: 1023 });
    return isTablet ? children : null;
  };
  const Mobile = ({ children }) => {
    const isMobile = useMediaQuery({ maxWidth: 767 });
    return isMobile ? children : null;
  };
  const Default = ({ children }) => {
    const isNotTabletAndMobile = useMediaQuery({
      minWidth: 768,
      maxWidth: 990,
    });
    return isNotTabletAndMobile ? children : null;
  };

  return (
    <>
      <Desktop>
        <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
          <div className='sm:grid-cols-3 grid sm:gap-2 gap-3 mt-6'>
            <div className=' overflow-hidden rounded-lg'>
              <div className='p-5'>
                <div className='flex items-center'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Font</span>
                  </div>
                  <div className=''>
                    <FormControl style={styles.formControl}>
                      <Select
                        input={<BootstrapInput />}
                        placeholder='Pilih Font'
                        defaultValue='Pilih Font'
                        onChange={handleChangeFont}
                      >
                        <MenuItem value='Pilih Font'>
                          <em>-- Pilih Font --</em>
                        </MenuItem>
                        <MenuItem value='Roboto, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Roboto'
                            fontStyle='Roboto, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Roboto Mono, monospaced'>
                          {' '}
                          <ListFont
                            fontName='Roboto Mono'
                            fontStyle='Roboto Mono, monospaced'
                          />
                        </MenuItem>
                        <MenuItem value='Qahiri, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Qahiri'
                            fontStyle='Qahiri, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='STIX Two Math, serif'>
                          {' '}
                          <ListFont
                            fontName='STIX Two Math'
                            fontStyle='STIX Two Math, serif'
                          />
                        </MenuItem>
                        <MenuItem value='Teko, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Teko'
                            fontStyle='Teko, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Bebas Neue, cursive'>
                          {' '}
                          <ListFont
                            fontName='Bebas Neue'
                            fontStyle='Bebas Neue, cursive'
                          />
                        </MenuItem>
                        <MenuItem value='Anton, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Anton'
                            fontStyle='Anton, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Barlow Condensed, sans-serif'>
                          {' '}
                          <ListFont
                            fontName='Barlow Condensed'
                            fontStyle='Barlow Condensed, sans-serif'
                          />
                        </MenuItem>
                        <MenuItem value='Source Code Pro, monospace'>
                          {' '}
                          <ListFont
                            fontName='Source Code Pro'
                            fontStyle='Source Code Pro, monospace'
                          />
                        </MenuItem>
                      </Select>
                    </FormControl>
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Paper Color</span>
                  </div>
                  <div
                    style={styles.swatch}
                    onClick={handleDisplayCPPaper}
                    className=''
                  >
                    <div
                      style={styles.paperColorTrigger}
                      message={styles.paperColor}
                    >
                      <span className='items-center text-center font-bold uppercase text-xs'>
                        {colorHexPaperCode}
                      </span>
                    </div>
                    {displayCPPaper ? (
                      <div style={styles.popover}>
                        <div style={styles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexPaperCode}
                          onChange={(e) => setColorHexPaperCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>
                      Background Paper Color
                    </span>
                  </div>
                  <div
                    style={styles.swatch}
                    onClick={handleDisplayCPBgPaper}
                    className=''
                  >
                    <div
                      style={styles.bgPaperColorTrigger}
                      message={styles.bgPaperColor}
                    >
                      <span className='items-center text-center font-bold uppercase text-xs'>
                        {colorHexPaperBgCode}
                      </span>
                    </div>
                    {displayCPBgPaper ? (
                      <div style={styles.popover}>
                        <div style={styles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexPaperBgCode}
                          onChange={(e) => setColorHexPaperBgCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Question Color</span>
                  </div>
                  <div
                    style={styles.swatch}
                    onClick={handleDisplayCPQuestion}
                    className=''
                  >
                    <div
                      style={styles.questionColorTrigger}
                      message={styles.questionColor}
                    >
                      <span className='items-center text-center font-bold uppercase text-xs'>
                        {colorHexQuestionCode}
                      </span>
                    </div>
                    {displayCPQuestion ? (
                      <div style={styles.popover}>
                        <div style={styles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexQuestionCode}
                          onChange={changeQuestion}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Answer Color</span>
                  </div>
                  <div
                    style={styles.swatch}
                    onClick={handleDisplayCPAnswer}
                    className=''
                  >
                    <div
                      style={styles.answerColorTrigger}
                      message={styles.answerColor}
                    >
                      <span className='items-center text-center font-bold uppercase text-xs'>
                        {colorHexAnswerCode}
                      </span>
                    </div>
                    {displayCPAnswer ? (
                      <div style={styles.popover}>
                        <div style={styles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexAnswerCode}
                          onChange={(e) => setColorHexAnswerCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className='flex flex-wrap items-center mb-4 mt-4'>
                  <div className='flex-auto'>
                    <span className='text-center text-md'>Strip Color</span>
                  </div>
                  <div
                    style={styles.swatch}
                    onClick={handleDisplayCPStrip}
                    className=''
                  >
                    <div
                      style={styles.stripColorTrigger}
                      message={styles.stripColor}
                    >
                      <span className='items-center text-center font-bold uppercase text-xs'>
                        {colorHexStripCode}
                      </span>
                    </div>
                    {displayCPStrip ? (
                      <div style={styles.popover}>
                        <div style={styles.cover} onClick={handleClose} />
                        <SketchPicker
                          color={colorHexStripCode}
                          onChange={(e) => setColorHexStripCode(e.hex)}
                        />
                      </div>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className='col-span-2 overflow-hidden rounded-lg'>
              <div className='p-5'>
                <div className='flex items-center'>
                  <div
                    className='overflow-hidden border-2 rounded px-4 py-4 flex-auto'
                    style={styles.bgPaperColor}
                  >
                    <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll'>
                      <ExampleColorPickerView
                        paperBg={styles.paperColor}
                        questionColor={styles.questionColor}
                        answerColor={styles.answerColor}
                        stripColor={styles.stripColor}
                        fontType={styles.fontStylee}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Desktop>
      <Tablet>
        <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
          <div className=' overflow-hidden rounded-lg'>
            <div className='p-5'>
              <div className='flex items-center'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Font</span>
                </div>
                <div className=''>
                  <FormControl style={styles.formControl}>
                    <Select
                      input={<BootstrapInput />}
                      placeholder='Pilih Font'
                      defaultValue='Pilih Font'
                      onChange={handleChangeFont}
                    >
                      <MenuItem value='Pilih Font'>
                        <em>-- Pilih Font --</em>
                      </MenuItem>
                      <MenuItem value='Roboto, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Roboto'
                          fontStyle='Roboto, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='Roboto Mono, monospaced'>
                        {' '}
                        <ListFont
                          fontName='Roboto Mono'
                          fontStyle='Roboto Mono, monospaced'
                        />
                      </MenuItem>
                      <MenuItem value='Qahiri, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Qahiri'
                          fontStyle='Qahiri, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='STIX Two Math, serif'>
                        {' '}
                        <ListFont
                          fontName='STIX Two Math'
                          fontStyle='STIX Two Math, serif'
                        />
                      </MenuItem>
                      <MenuItem value='Teko, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Teko'
                          fontStyle='Teko, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='Bebas Neue, cursive'>
                        {' '}
                        <ListFont
                          fontName='Bebas Neue'
                          fontStyle='Bebas Neue, cursive'
                        />
                      </MenuItem>
                      <MenuItem value='Anton, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Anton'
                          fontStyle='Anton, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='Barlow Condensed, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Barlow Condensed'
                          fontStyle='Barlow Condensed, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='Source Code Pro, monospace'>
                        {' '}
                        <ListFont
                          fontName='Source Code Pro'
                          fontStyle='Source Code Pro, monospace'
                        />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Paper Color</span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPPaper}
                  className=''
                >
                  <div
                    style={styles.paperColorTrigger}
                    message={styles.paperColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexPaperCode}
                    </span>
                  </div>
                  {displayCPPaper ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexPaperCode}
                        onChange={(e) => setColorHexPaperCode(e.hex)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>
                    Background Paper Color
                  </span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPBgPaper}
                  className=''
                >
                  <div
                    style={styles.bgPaperColorTrigger}
                    message={styles.bgPaperColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexPaperBgCode}
                    </span>
                  </div>
                  {displayCPBgPaper ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexPaperBgCode}
                        onChange={(e) => setColorHexPaperBgCode(e.hex)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Question Color</span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPQuestion}
                  className=''
                >
                  <div
                    style={styles.questionColorTrigger}
                    message={styles.questionColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexQuestionCode}
                    </span>
                  </div>
                  {displayCPQuestion ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexQuestionCode}
                        onChange={changeQuestion}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Answer Color</span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPAnswer}
                  className=''
                >
                  <div
                    style={styles.answerColorTrigger}
                    message={styles.answerColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexAnswerCode}
                    </span>
                  </div>
                  {displayCPAnswer ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexAnswerCode}
                        onChange={(e) => setColorHexAnswerCode(e.hex)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Strip Color</span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPStrip}
                  className=''
                >
                  <div
                    style={styles.stripColorTrigger}
                    message={styles.stripColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexStripCode}
                    </span>
                  </div>
                  {displayCPStrip ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexStripCode}
                        onChange={(e) => setColorHexStripCode(e.hex)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className='col-span-2 overflow-hidden rounded-lg'>
            <div className='p-5'>
              <div className='flex items-center'>
                <div
                  className='overflow-hidden border-2 rounded px-4 py-4 flex-auto'
                  style={styles.bgPaperColor}
                >
                  <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll'>
                    <ExampleColorPickerView
                      paperBg={styles.paperColor}
                      questionColor={styles.questionColor}
                      answerColor={styles.answerColor}
                      stripColor={styles.stripColor}
                      fontType={styles.fontStylee}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Tablet>
      <Mobile>
        <div className='bg-white overflow-hidden shadow-md rounded-lg py-4'>
          <div className=' overflow-hidden rounded-lg'>
            <div className='p-5'>
              <div className='flex items-center'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Font</span>
                </div>
                <div className=''>
                  <FormControl style={styles.formControl}>
                    <Select
                      input={<BootstrapInput />}
                      placeholder='Pilih Font'
                      defaultValue='Pilih Font'
                      onChange={handleChangeFont}
                    >
                      <MenuItem value='Pilih Font'>
                        <em>-- Pilih Font --</em>
                      </MenuItem>
                      <MenuItem value='Roboto, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Roboto'
                          fontStyle='Roboto, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='Roboto Mono, monospaced'>
                        {' '}
                        <ListFont
                          fontName='Roboto Mono'
                          fontStyle='Roboto Mono, monospaced'
                        />
                      </MenuItem>
                      <MenuItem value='Qahiri, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Qahiri'
                          fontStyle='Qahiri, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='STIX Two Math, serif'>
                        {' '}
                        <ListFont
                          fontName='STIX Two Math'
                          fontStyle='STIX Two Math, serif'
                        />
                      </MenuItem>
                      <MenuItem value='Teko, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Teko'
                          fontStyle='Teko, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='Bebas Neue, cursive'>
                        {' '}
                        <ListFont
                          fontName='Bebas Neue'
                          fontStyle='Bebas Neue, cursive'
                        />
                      </MenuItem>
                      <MenuItem value='Anton, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Anton'
                          fontStyle='Anton, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='Barlow Condensed, sans-serif'>
                        {' '}
                        <ListFont
                          fontName='Barlow Condensed'
                          fontStyle='Barlow Condensed, sans-serif'
                        />
                      </MenuItem>
                      <MenuItem value='Source Code Pro, monospace'>
                        {' '}
                        <ListFont
                          fontName='Source Code Pro'
                          fontStyle='Source Code Pro, monospace'
                        />
                      </MenuItem>
                    </Select>
                  </FormControl>
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Paper Color</span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPPaper}
                  className=''
                >
                  <div
                    style={styles.paperColorTrigger}
                    message={styles.paperColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexPaperCode}
                    </span>
                  </div>
                  {displayCPPaper ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexPaperCode}
                        onChange={(e) => setColorHexPaperCode(e.hex)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>
                    Background Paper Color
                  </span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPBgPaper}
                  className=''
                >
                  <div
                    style={styles.bgPaperColorTrigger}
                    message={styles.bgPaperColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexPaperBgCode}
                    </span>
                  </div>
                  {displayCPBgPaper ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexPaperBgCode}
                        onChange={(e) => setColorHexPaperBgCode(e.hex)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Question Color</span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPQuestion}
                  className=''
                >
                  <div
                    style={styles.questionColorTrigger}
                    message={styles.questionColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexQuestionCode}
                    </span>
                  </div>
                  {displayCPQuestion ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexQuestionCode}
                        onChange={changeQuestion}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Answer Color</span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPAnswer}
                  className=''
                >
                  <div
                    style={styles.answerColorTrigger}
                    message={styles.answerColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexAnswerCode}
                    </span>
                  </div>
                  {displayCPAnswer ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexAnswerCode}
                        onChange={(e) => setColorHexAnswerCode(e.hex)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
              <div className='flex flex-wrap items-center mb-4 mt-4'>
                <div className='flex-auto'>
                  <span className='text-center text-md'>Strip Color</span>
                </div>
                <div
                  style={styles.swatch}
                  onClick={handleDisplayCPStrip}
                  className=''
                >
                  <div
                    style={styles.stripColorTrigger}
                    message={styles.stripColor}
                  >
                    <span className='items-center text-center font-bold uppercase text-xs'>
                      {colorHexStripCode}
                    </span>
                  </div>
                  {displayCPStrip ? (
                    <div style={styles.popover}>
                      <div style={styles.cover} onClick={handleClose} />
                      <SketchPicker
                        color={colorHexStripCode}
                        onChange={(e) => setColorHexStripCode(e.hex)}
                      />
                    </div>
                  ) : null}
                </div>
              </div>
            </div>
          </div>

          <div className='col-span-2 overflow-hidden rounded-lg'>
            <div className='p-3'>
              <div className='flex items-center'>
                <div
                  className='overflow-hidden border-2 rounded py-4 flex-auto'
                  style={styles.bgPaperColor}
                >
                  <div className='px-6 py-4 content-box flex-col justify-center items-center rounded overflow-y-scroll'>
                    <ExampleColorPickerView
                      paperBg={styles.paperColor}
                      questionColor={styles.questionColor}
                      answerColor={styles.answerColor}
                      stripColor={styles.stripColor}
                      fontType={styles.fontStylee}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Mobile>
    </>
  );
}
